import PropTypes from "prop-types"
import DetailsSelectionHOC from "./details_selection_hoc"
import AppletMetrics from "../applet_metrics/applet_metrics"
import AppletsSelectorContent from "./applet_selector_content"

const AppletsPage = props => {
  const PeriodWrapped = ({ selection, ...props }) => {
    const appletProps = {
      ...props,
      subHeaderText: `Applet adoption and engagement metrics`,
      headerText: `Applet usage`,
    }
    if (selection.data.id !== -1) {
      appletProps.appletSlug = selection.data.id
    }

    return <AppletMetrics {...appletProps} />
  }

  const AppletContent = (appletName, currentMetricDate) => (
    <AppletsSelectorContent
      serviceName={props.serviceName}
      serviceModuleName={props.serviceModuleName}
      appletName={appletName}
      currentMetricDate={currentMetricDate}
    />
  )

  const AppletsContainer = DetailsSelectionHOC({
    WrappedComponent: PeriodWrapped,
    options: [
      {
        data: {
          id: -1,
          name: "All",
        },
        ContentComponent: AppletContent,
      },
    ].concat(
      props.items.map(applet => {
        return {
          ...applet,
          ContentComponent: AppletContent,
        }
      })
    ),
    rootUrl: "applets",
    serviceTitle: props.serviceName,
    serviceColor: props.serviceColor,
    serviceImage: props.serviceImage,
    initialSelection: props.appletSlug
      ? props.items.find(i => i.data.id == props.appletSlug)
      : null,
  })

  return <AppletsContainer {...props} />
}

AppletsPage.propTypes = {
  items: PropTypes.array,
  serviceName: PropTypes.string,
  serviceModuleName: PropTypes.string,
  serviceColor: PropTypes.string,
  serviceImage: PropTypes.string,
  appletSlug: PropTypes.string,
  servicesUrl: PropTypes.string,
}

export default AppletsPage
